import type { MRT_ColumnDef, MRT_RowData } from "mantine-react-table-open";
import { MantineYesNoRadioGroup } from "../../../../../../mantine/mrt/components/cell/MantineYesNoRadioGroup";
import { ControlledMantineEditYesNoRadioGroup } from "../../../../../../mantine/mrt/components/edit/ControlledMantineEditYesNoRadioGroup";

export function getIsParticipatingInMieterstromColumn<T extends MRT_RowData>(
  hasCellError: (rowIndex: number, accessorKey: keyof T) => boolean
): MRT_ColumnDef<T> {
  return {
    accessorKey: "isParticipatingInMieterstrom",
    header: "Teilnahme am Mieterstrommodell",
    Edit: ({ row, cell, column }) => {
      return (
        <ControlledMantineEditYesNoRadioGroup
          allowInput
          cell={cell}
          columnId={column.id}
          row={row}
        />
      );
    },
    Cell: ({ row }) => (
      <MantineYesNoRadioGroup
        allowInput={false}
        checked={row.original.isParticipatingInMieterstrom}
        errorText={
          hasCellError(row.index, "isParticipatingInMieterstrom")
            ? "Bitte wählen Sie eine Option aus."
            : undefined
        }
      />
    )
  };
}
